class ProductSlider extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('.swiper');
        this.pagination = this.querySelector('.swiper-pagination');
        this.prevArrow = this.querySelector('.cstm-swiper-button-prev');
        this.nextArrow = this.querySelector('.cstm-swiper-button-next');
    }
    connectedCallback() {
        this.init();
    }

    initSlider() {
        this.activeSlider = new Swiper(this.slider, {
            slidesPerView: 1.35,
            spaceBetween: 18,
            autoHeight: false,
            freeMode: true,
            mousewheel: {
                forceToAxis: true
            },
            loop: false,
            pagination: {
                el: this.pagination,
                clickable: true,
                type: "progressbar",
            },
            navigation: {
                nextEl: this.nextArrow,
                prevEl: this.prevArrow,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 22,
                },
                1024: {
                    slidesPerView: 4.5,
                    spaceBetween: 26,
                },
            },
        });
    }

    init() {
        const checkSwiper = setInterval(() => {
            if (typeof Swiper !== 'undefined') {
                this.initSlider();
                clearInterval(checkSwiper);
            }
        }, 100);
    }
}

if (!customElements.get('prduct-slider')) {
    customElements.define('prduct-slider', ProductSlider);
}